import "@/App.css";
import { Toaster } from "sonner";
import { useLenis } from "@/components/landing/shared";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { DocsWorkflows } from "@/components/landing/DocsWorkflows";
import { ContactForm } from "@/components/landing/ContactForm";
import { Footer } from "@/components/landing/Footer";

function App() {
  useLenis();

  return (
    <div className="App relative bg-background">
      <div className="grain" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid rgba(255,255,255,0.15)",
            background: "#0A0A0A",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
          },
        }}
      />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <DocsWorkflows />
        <ContactForm />
        <Footer />
      </main>
    </div>
  );
}

export default App;
